import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { SortDirectionEnum, SortDirectionType } from '../../../data-filter';

@Component({
  selector: 'app-sort-header-option',
  templateUrl: './sort-header-option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SortHeaderOptionComponent {
  @HostBinding('class')
  private readonly classes = 'group flex';

  @Input()
  icon: string;

  @Input()
  sortEnabled: boolean;

  @Input()
  text: string;

  @Input()
  infoTooltipText: string;

  @Input()
  sortDirection: SortDirectionType;

  get isCaretShown(): boolean {
    return !!this.sortDirection;
  }

  get isCaretRotated(): boolean {
    return this.isCaretShown && (this.sortDirection === SortDirectionEnum.DSC);
  }
}
